import { render, staticRenderFns } from "./VariantSifterMappingBar.vue?vue&type=template&id=50b37406&scoped=true&"
import script from "./VariantSifterMappingBar.vue?vue&type=script&lang=js&"
export * from "./VariantSifterMappingBar.vue?vue&type=script&lang=js&"
import style0 from "./VariantSifterMappingBar.vue?vue&type=style&index=0&id=50b37406&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b37406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Portal (Dev)/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('50b37406')) {
      api.createRecord('50b37406', component.options)
    } else {
      api.reload('50b37406', component.options)
    }
    module.hot.accept("./VariantSifterMappingBar.vue?vue&type=template&id=50b37406&scoped=true&", function () {
      api.rerender('50b37406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/kpVariantSifter/VariantSifterMappingBar.vue"
export default component.exports